import Conexion_api from "@/api/Conexion_api.js";

const obtener_zonas = function(){
  return new Promise((resuelve, rechaza) => {
    Conexion_api({
      body: {
        coordenadas: this.usuario.coordenadas,
      },
      evento: "configuraciones_generales/obtener_zonas_cliente",
    })
    .then((respuesta) => {
      if (respuesta.data.error) {
        this.$root.$emit("snackbar", {
          color: "error",
          texto: respuesta.data.error,
        });
        rechaza(false); 
        return;
      }
      resuelve(respuesta.data.datos.zonas);
    })
    .catch((err) => {
      err = String(err);
      this.$root.$emit("snackbar", { color: "error", texto: err });
      console.error(err);
      rechaza(false); 
    });
  })
}
export default obtener_zonas